import { render, staticRenderFns } from "./CleanMessageConfirm.vue?vue&type=template&id=7915eb59"
import script from "./CleanMessageConfirm.vue?vue&type=script&lang=js"
export * from "./CleanMessageConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports